import { render, staticRenderFns } from "./SSOSignUpDialog.vue?vue&type=template&id=2b514893&scoped=true"
import script from "./SSOSignUpDialog.vue?vue&type=script&lang=ts"
export * from "./SSOSignUpDialog.vue?vue&type=script&lang=ts"
import style0 from "./SSOSignUpDialog.vue?vue&type=style&index=0&id=2b514893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b514893",
  null
  
)

export default component.exports